import styled from 'styled-components';

export const MainContainer = styled.div`
  margin: 20px 16px;
  display: flex;
  justify-content: center;

  .title {
    font-family: Lato;
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: left;
    color: #161d1f;
    margin-bottom: 16px;
  }

  .content {
    margin-bottom: 16px;
  }
  @media (min-width: 992px) {
    margin-left: 88px;
    margin-top: 72px;
    margin-right: 0;
    margin-bottom: 0;
    .container {
      padding: 12px 32px;
    }
  }
`;

export const BackButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-bottom: 16px;
`;

export const ResumenGeneralContainer = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;

  p {
    margin: 0 0 10px 0;
    font-size: 14px;
    color: #333333;
  }

  .resumen-general-title {
    font-family: Lato;
    font-size: 14px;
    font-weight: 900;
    line-height: 20px;
    text-align: left;
    color: #161d1f;
    padding: 12px 16px;
  }

  .line {
    height: 1px;
    border: 1px solid #e6edf2;
  }

  .resumen-general-content {
    padding: 16px;
    gap: 6px;
    border-radius: 0px 0px 8px 8px;
    box-shadow: 0px 1.2px 4px 0px #eaeef1;
    color: #161d1f;
    display: flex;
    flex-direction: column;
    .row {
      flex: 1;
      gap: 6px;
      display: flex;
      flex-direction: column;
    }
    @media (min-width: 640px) {
      display: flex;
      width: 100%;
      flex-direction: row;
    }
  }
`;

export const DownloadButton = styled.button`
  display: flex;
  width: Fill (115px) px;
  height: Hug (44px) px;
  padding: 10px 24px 10px 16px;
  gap: 8px;
  border-radius: 4px;
  background: #ffffff;
  color: #5b36f2;
  font-family: Lato;
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  align-items: center;
  border: 1px solid #5b36f2;
`;

export const CicloCursosContainer = styled.div`
  border-radius: 8px;
  background: #ffffff;
  display: flex;
  margin-bottom: 8px;
  &::before {
    content: ' ';
    min-width: 4px;
    width: 4px;
    background-color: #5b36f2;
    display: flex;
    border-bottom-left-radius: 8px;
    border-top-left-radius: 8px;
    height: auto;
  }

  .table-wrapper {
    margin-top: 8px;
    overflow-x: auto;
    ::-webkit-scrollbar {
      height: 6px;
    }

    ::-webkit-scrollbar-thumb {
      background-color: #b0c0ca;
      border-radius: 4px;
    }

    ::-webkit-scrollbar-track {
      background-color: #ffffff;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th,
  td {
    padding: 8px 16px;
    text-align: left;
    color: #3c4662;
    border-bottom: 1px solid #dedede;
  }

  th {
    background: #f5f5f5;
    text-align: left;
    font-weight: bold;
  }

  td:not(:nth-child(2)) {
    text-align: right;
  }

  /* Ciclo */
  th:nth-child(1),
  td:nth-child(1) {
    min-width: 64px;
    width: 64px;
  }

  /* Código de curso */
  th:nth-child(2),
  td:nth-child(2) {
    min-width: 120px;
    width: 120px;
  }

  /* Curso */
  th:nth-child(3),
  td:nth-child(3) {
    min-width: 381px;
    width: 381px;
    max-width: 381px;
    text-align: left;
  }

  /* Número de vez */
  th:nth-child(4),
  td:nth-child(4) {
    min-width: 85px;
    width: 85px;
  }

  /* Horas semanales */
  th:nth-child(5),
  td:nth-child(5) {
    min-width: 97px;
    width: 97px;
  }

  /* Créditos */
  th:nth-child(6),
  td:nth-child(6) {
    min-width: 85px;
    width: 85px;
  }

  /* Nota */
  th:nth-child(7),
  td:nth-child(7) {
    min-width: 63px;
    width: 63px;
  }

  /* Sección */
  th:nth-child(8),
  td:nth-child(8) {
    min-width: 81px;
    width: 81px;
  }

  /* Estado */
  th:nth-child(9),
  td:nth-child(9) {
    min-width: 128px;
    width: 128px;
    text-align: left;
    height: 60px;
  }
`;

export const CicloHeader = styled.div`
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  margin-right: 8px;
  margin-left: 12px;

  h4 {
    margin: 0;
    color: #1e40af;
  }

  .toggle-icon {
    font-size: 20px;
    color: #5b36f2;
    display: flex;
    width: 44px;
    height: 44px;
    align-items: center;
    justify-content: center;
  }
`;

export const getColorByStatus = (status: string) => {
  switch (status) {
    case 'Aprobado':
      return '#A8F1BB';
    case 'Desaprobado':
      return '#FED4D6';
    case 'Retirado':
      return '#FFFFFF';
    case 'En Curso':
      return '#FDDC70';
    default:
      return '#FFFFFF';
  }
};

export const getBackgroundColorByStatus = (status: string) => {
  switch (status) {
    case 'Aprobado':
      return '#005C27';
    case 'Desaprobado':
      return '#890722';
    case 'Retirado':
      return '#8090BB';
    case 'En Curso':
      return '#694900';
    default:
      return '#007B77';
  }
};

export const StatusBadge = styled.span<{ status: string }>`
  padding: 4px 12px;
  border-radius: 20px;
  color: ${(props) => getColorByStatus(props.status)};
  background-color: ${(props) => getBackgroundColorByStatus(props.status)};
`;
